import { AdminUserPermissionsEnum } from '@/lib/enum';
import { CommaSeparator } from '@/components/custom';
import { SecuredComponent } from '@/components/hoc';
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import routes from '@/lib/routes';
import type { MouseEvent } from 'react';
import type { TProps } from '.';

const BannerUserInfosDeviceAccountsCount = ({ user }: Pick<TProps, 'user'>) => {

	const navigate = useNavigate();

	const handleOnClickBtnActiveAccount = (e: MouseEvent<HTMLButtonElement>) => {
		// Stop propagation of event
		e.stopPropagation();
		// Redirect
		navigate(`${routes.nav.users.single.getHref(user._id)}?tab=subAccounts`);
	};

	if (!(!!user?.deviceAccountsCount && user?.deviceAccountsCount > 1)) {
		return null;
	}

	return (
		<SecuredComponent permissionsRequired={[AdminUserPermissionsEnum.USERS_SUB_ACCOUNTS]}>
			<button
				type='button'
				className='flex items-center space-x-1 cursor-pointer bg-transparent border-none p-0'
				onClick={handleOnClickBtnActiveAccount}
				title='Nombre de comptes actif'>
				<CommaSeparator />
				<span className='text-sm font-semibold text-purple-600'>
					{user.deviceAccountsCount ?? -1}
				</span>
				<Users
					size={16}
					className='text-purple-600' />
			</button>
		</SecuredComponent>
	);

};

export default BannerUserInfosDeviceAccountsCount;
